/* Mobilmeny: pila åpner og lukker undersidene. Fokus flyttes ikke til første lenke ved trykk (gir den store røde rammen). */
(function(){
  var mq=window.matchMedia('(max-width:1180px)');
  document.querySelectorAll('.v2-nav-caret').forEach(function(c){ if(mq.matches) c.setAttribute('tabindex','0'); });
  document.addEventListener('click',function(e){
    var c=e.target.closest && e.target.closest('.v2-nav.is-open .v2-nav-caret');
    if(!c||!mq.matches) return;
    e.preventDefault(); e.stopImmediatePropagation();
    c.setAttribute('aria-expanded', c.getAttribute('aria-expanded')==='true' ? 'false' : 'true');
  },true);
  var lastPointer=0;
  document.addEventListener('pointerdown',function(){ lastPointer=Date.now(); },true);
  document.addEventListener('focusin',function(e){
    var nav=e.target.closest && e.target.closest('.v2-nav.is-open');
    if(nav && mq.matches && Date.now()-lastPointer<800 && e.target.matches('.v2-nav-parent')){
      if(!nav.hasAttribute('tabindex')) nav.setAttribute('tabindex','-1');
      nav.focus({preventScroll:true});
    }
  });
})();
